

module.exports = __webpack_require__.stylable.create(
    "Notification953574627",
    {"classes":{"root":"Notification953574627__root","animatorContent":"Notification953574627__animatorContent","wrapper":"Notification953574627__wrapper","notification":"Notification953574627__notification","animator":"Notification953574627__animator","labelWrapper":"Notification953574627__labelWrapper","label":"Notification953574627__label","button":"Notification953574627__button","textLink":"Notification953574627__textLink","iconStyling":"Notification953574627__iconStyling","closeButton":"Notification953574627__closeButton"},"vars":{},"stVars":{"zIndex_NOTIFICATION":"4000"},"keyframes":{}},
    "",
    2,
    "Notification953574627",
    null
);
